import { RecentlyViewed } from '@theme/recently-viewed-products';

document.addEventListener('DOMContentLoaded', async () => {
  const wrapper = document.getElementById('recently-viewed-slider');
  if (!wrapper) return;

  const currentId = wrapper.dataset.currentProductId;
  const sectionId = wrapper.dataset.sectionId;
  const viewed = RecentlyViewed.getProducts().filter((id) => id !== currentId);

  if (viewed.length === 0 || !sectionId) return;

  const url = new URL('/search', window.location.origin);
  url.searchParams.set('q', viewed.map((id) => `id:${id}`).join(' OR '));
  url.searchParams.set('resources[type]', 'product');
  url.searchParams.set('section_id', sectionId);

  try {
    const response = await fetch(url.toString());
    if (!response.ok) return;

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const grid = doc.getElementById('predictive-search-products');
    const items = grid ? grid.querySelectorAll('.predictive-search-results__card--product') : [];

    if (!items.length) return;

    const target = document.getElementById('recently-viewed-slider__grid');
    if (!target) return;

    target.replaceChildren(...items);
    wrapper.hidden = false;
  } catch (error) {
    // Recently viewed is a non-critical enhancement; fail silently.
  }
});
